import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import * as AiIcons from "react-icons/ai";
import UpdateAreaN2 from './UpdateAreaN2';
import { FaEdit } from "react-icons/fa";
import { MdAccountTree } from "react-icons/md";
import { BsPersonLinesFill } from "react-icons/bs";
import UpdatePosicion from './UpdatePosicion';
import { dtFormatter } from './AuxiliaryFunctions';
import UpdateCompetencia from './UpdateCompetencia';
import OrganigramaAreaDataService from './services/organigramaarea.service';
import AsignarOrganigrama from './AsignarOrganigrama';

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>ID Competencia</th>
        <th style={{width:'10%'}}>Nombre Competencia</th>
        <th style={{width:'25%'}}>Descripción Competencia</th>
        <th style={{width:'10%'}}>Fecha de inicio</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Fecha de fin</th>
        <th style={{width:'5%'}}>{props.mode==0?'Editar ':''}</th>
        <th style={{width:'25%'}}>{'Organigrama (Asignar o Editar)'}</th>
        <th style={{width:'10%'}}>{'Listado de jueces'}</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {  
  
  if (props.listOfCompetencias) {
    
    const rows = props.listOfCompetencias.map((row, index) => { 
      return (      
        <tr key={index}>        
          <td>
            {"COM-" + row.id}
          </td>
          <td>  
            {row.nombrecompetencia}
          </td>
          <td>  
            {row.descripcioncompetencia}
          </td>          
          <td className='d-none d-sm-table-cell'>  
            {dtFormatter(new Date(row.fechainicio),1)}
          </td>             
          <td className='d-none d-sm-table-cell'>  
            {dtFormatter(new Date(row.fechafin),1)}
          </td>

          <td align='center'>  
            {(props.mode==0) && // editar
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderEditTooltip}>        
                <UpdateCompetencia 
                  editrow = {row}
                  id = {row.id}
                  nombrecompetencia = {row.nombrecompetencia}
                  descripcioncompetencia = {row.descripcioncompetencia}
                  fechainicio = {row.fechainicio}
                  fechafin = {row.fechafin}
                  mode={0}/>    
              </OverlayTrigger>              
            }
            {(props.mode==1) && // seleccionar
              <Button onClick={() => {
                //console.log(row);
                props.onSelected(row.id,row.nombrecompetencia,row.descripcioncompetencia);
                props.handleClose();
              }} variant='link' value={row.id}>Seleccionar</Button>
            } 
          </td>  
          <td>
            <AsignarOrganigrama 
              id={row.id} competencia={row}
            />
          </td> 
          <td>            
            {/*organigrama/competencia/usuario */}
            <Button variant="secondary"><Link to = {`/listadejuecescompetencia/${row.organigramaId}/${row.id}/${"all"}`}><BsPersonLinesFill size={15} color='white'/></Link></Button>
          </td>                
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the user.
  </Tooltip>
);

const CompetenciasList = (props) => {        
  //console.log(props);
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode}/>
            <TableBody row={props.row} mode={props.mode} handleClose={props.handleClose} onSelected={props.onSelected} arean2id={props.arean2id} listOfCompetencias={props.listOfCompetencias} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
};

export default CompetenciasList;